module.exports = __webpack_public_path__ + "img/2024080214495788kzF.3efb6a3f.png";